import React from 'react';
import { CalendarFilled } from '@ant-design/icons';

export const CalendarEventsHeader = () => {
	return (
		<div className="flex gap-3">
			<span className="inline-flex items-center text-[#1d4ed8] bg-[#3b82f6]/10 justify-center w-10 h-10 rounded-lg text-2xl font-bold">
				<CalendarFilled />
			</span>
			<div>
				<h2 className="text-2xl font-bold text-gray-900 mb-0">Calendar</h2>
				<p className="text-gray-500 text-sm">
					Manage your AI receptionist's schedule and appointments.
				</p>
			</div>
		</div>
	);
};
